export default {
  loading: false,
  customer_list: [],
  sales_user_list: [],
  reports_data: [],
  total: 0,
  FilteredCount: 0,
  records_loading: false
}
